<template>
    <div class="empty-state" v-if="empty">
        <component class="" v-if="icon" v-bind:is="icon"></component>
        <span>{{ emptyText }}</span>
    </div>
    <div class="page-layout" v-else>
        <header>
            <!--<slot name="header"></slot>-->
        </header>
        <slot class="page-slot"></slot>
    </div>
</template>

<script type="text/babel">
import icons from '@/assets/icons';

export default {
  props: {
    empty: {
      required: false,
      default: false,
      type: Boolean,
    },
    emptyText: {
      type: String,
      required: false,
      default: 'Schade, in dieser Kategorie wurde noch nichts gespeichert.',
    },
  },
  computed: {
    icon() {
      const { icon } = this.$config.navigation[this.$route.name];
      // eslint-disable-next-line
      return icons[icon];
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
    .page-layout {
        display: grid;
        grid-auto-rows: min-content 1fr;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        > div {
            &::-webkit-scrollbar {
                width: .5em;
            }
            &::-webkit-scrollbar-track {
                background: #eee;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: .25em;
                background:
                  linear-gradient(to top, var(--gradient-color-1), var(--gradient-color-2));
            }
        }
    }
    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 1.25em;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        svg {
            width: 10em;
        }
    }
</style>
